import React from "react";

const SEGS = [
  { key: "rebooked", label: "Rebooked", color: "#81B29A", hint: "Left with their next appointment booked" },
  { key: "later", label: "Rebooking later", color: "#9DB7CF", hint: "Told us they'll book when they can — we text them a link when the time comes" },
  { key: "in_window", label: "Still in window", color: "#D6C5AD", hint: "Not due back yet for this treatment's normal gap" },
  { key: "one_off", label: "One-off", color: "#C5C2B8", hint: "One-visit service or client not expected back — doesn't count either way" },
  { key: "not_yet", label: "Not yet", color: "#E07A5F", hint: "Past their normal gap with nothing booked — these are the ones to chase" },
];

export const RebookBreakdown = ({ bd, compact = false, testid = "rebook-breakdown" }) => {
  if (!bd || !bd.seen) return <div className="text-xs text-muted-foreground" data-testid={testid}>No visits in this period yet.</div>;
  const total = bd.seen || 1;
  return (
    <div data-testid={testid}>
      <div className="flex items-baseline gap-2 mb-2">
        <span className="font-heading font-bold text-2xl tabular-nums" data-testid={`${testid}-rate`}>{bd.rate == null ? "—" : `${bd.rate}%`}</span>
        <span className="text-xs text-muted-foreground">on track · only "Not yet" counts against you{bd.one_off ? ` · ${bd.one_off} one-off excluded` : ""}</span>
      </div>
      <div className="h-3 rounded-full overflow-hidden flex bg-muted" title={`${bd.seen} clients seen`}>
        {SEGS.map((s) => bd[s.key] > 0 && <div key={s.key} style={{ width: `${(bd[s.key] / total) * 100}%`, background: s.color }} title={`${s.label}: ${bd[s.key]}`} data-testid={`${testid}-seg-${s.key}`} />)}
      </div>
      <div className={`mt-2 grid ${compact ? "grid-cols-2 sm:grid-cols-5" : "grid-cols-2 md:grid-cols-5"} gap-x-3 gap-y-1`}>
        {SEGS.map((s) => (
          <div key={s.key} className="flex items-center gap-1.5 text-xs" title={s.hint}>
            <span className="h-2.5 w-2.5 rounded-sm shrink-0" style={{ background: s.color }} />
            <span className="text-muted-foreground truncate">{s.label}</span>
            <span className="font-semibold tabular-nums ml-auto" data-testid={`${testid}-${s.key}`}>{bd[s.key] || 0}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
